export interface SmsConfig {
  id?: string;
  centerGroupId?: number;
  isActive: boolean;
  accountSid: string;
  authToken: string;
  fromPhoneNumber: string;
  maxSmsPerHourPerUser: number;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface SmsCreateRequest {
  accountSid: string;
  authToken: string;
  fromPhoneNumber: string;
  maxSmsPerHourPerUser?: number;
}

export interface SmsUpdateRequest {
  accountSid?: string | null;
  authToken?: string | null;
  fromPhoneNumber?: string | null;
  maxSmsPerHourPerUser?: number | null;
  isActive?: boolean;
}

export interface SmsTestResponse {
  success: boolean;
  message: string;
  testedAt?: string;
}
